/**
 * HELPER TO HIDE EL WITH DELAY
 */
jQuery.fn.delayHide = function () {
	let $this = $( this );
	clearTimeout( $this.data( 'hideTimeout' ) );
	$this.data( 'hideTimeout', setTimeout(
		() => {
			$this.css( { display: 'none' } );
		}, 200
	) );
	return $this;
};

jQuery.fn.delayShow = function () {
	let $this = $( this );
	clearTimeout( $this.data( 'hideTimeout' ) );
	$this.css( { display: '', visibility: '' } );
	return $this;
};

jQuery.fn.blink = function () {
	let $this = $( this );

	//$this.fadeOut( 100 ).fadeIn( 300 );
	$this.finish().addClass( 'blink' ).delay( 600 ).queue( function () {
		$( this ).removeClass( 'blink' );
		$( this ).dequeue();
	} );

	return $this;
};

jQuery.fn.scrollIntoViewIfNeeded = function ( centerIfNeeded/*, scrollParent*/ ) {
	if ( !this || !$( this )[ 0 ] ) return null;

	let targetElement = this[ 0 ];
	//let targetParent = $( scrollParent )[ 0 ];

	targetElement.scrollIntoViewIfNeeded( centerIfNeeded/*, targetParent*/ );
};

/*Element.prototype.scrollIntoViewIfNeeded = function ( centerIfNeeded, scrollParent ) {
	centerIfNeeded = arguments.length === 0 ? true : !!centerIfNeeded;

	let parent                = scrollParent || this.parentNode,
	    parentComputedStyle   = window.getComputedStyle( parent, null ),
	    parentBorderTopWidth  = parseInt( parentComputedStyle.getPropertyValue( 'border-top-width' ) ),
	    parentBorderLeftWidth = parseInt( parentComputedStyle.getPropertyValue( 'border-left-width' ) ),
	    overTop               = this.offsetTop - parent.offsetTop < parent.scrollTop,
	    overBottom            = ( this.offsetTop - parent.offsetTop + this.clientHeight - parentBorderTopWidth ) > ( parent.scrollTop + parent.clientHeight ),
	    overLeft              = this.offsetLeft - parent.offsetLeft < parent.scrollLeft,
	    overRight             = ( this.offsetLeft - parent.offsetLeft + this.clientWidth - parentBorderLeftWidth ) > ( parent.scrollLeft + parent.clientWidth ),
	    alignWithTop          = overTop && !overBottom;

	if ( ( overTop || overBottom ) && centerIfNeeded ) {
		parent.scrollTop = this.offsetTop - parent.offsetTop - parent.clientHeight / 2 - parentBorderTopWidth + this.clientHeight / 2;
	}

	if ( ( overLeft || overRight ) && centerIfNeeded ) {
		parent.scrollLeft = this.offsetLeft - parent.offsetLeft - parent.clientWidth / 2 - parentBorderLeftWidth + this.clientWidth / 2;
	}

	if ( ( overTop || overBottom || overLeft || overRight ) && !centerIfNeeded ) {
		this.scrollIntoView( alignWithTop );
	}
};*/


Element.prototype.scrollIntoViewIfNeeded = function ( centerIfNeeded ) {
	"use strict";

	function makeRange ( start, length ) {
		return { "start": start, "length": length, "end": start + length };
	}

	function coverRange ( inner, outer ) {
		if (
			false === centerIfNeeded ||
			( outer.start < inner.end && inner.start < outer.end )
		) {
			return Math.max(
				inner.end - outer.length,
				Math.min( outer.start, inner.start )
			);
		}
		return ( inner.start + inner.end - outer.length ) / 2;
	}

	function makePoint ( x, y ) {
		return {
			"x"        : x,
			"y"        : y,
			"translate": function translate ( dX, dY ) {
				return makePoint( x + dX, y + dY );
			}
		};
	}

	function absolute ( elem, pt ) {
		while ( elem ) {
			pt = pt.translate( elem.offsetLeft, elem.offsetTop );
			elem = elem.offsetParent;
		}
		return pt;
	}

	var target = absolute( this, makePoint( 0, 0 ) ),
	    extent = makePoint( this.offsetWidth, this.offsetHeight ),
	    elem   = this.parentNode,
	    origin;

	while ( elem instanceof HTMLElement ) {
		// Apply desired scroll amount.
		origin = absolute( elem, makePoint( elem.clientLeft, elem.clientTop ) );
		elem.scrollLeft = coverRange(
			makeRange( target.x - origin.x, extent.x ),
			makeRange( elem.scrollLeft, elem.clientWidth )
		);
		elem.scrollTop = coverRange(
			makeRange( target.y - origin.y, extent.y ),
			makeRange( elem.scrollTop, elem.clientHeight )
		);

		// Determine actual scroll amount by reading back scroll properties.
		target = target.translate( -elem.scrollLeft, -elem.scrollTop );
		elem = elem.parentNode;
	}
};

Element.prototype.scrollHLIntoView = function ( forced = false, scrollParent = null, smooth = true, ratio = 1 ) {
	let $el          = $( this ),
	    parent       = scrollParent || this.parentNode,
	    rcParent     = parent.getBoundingClientRect(),
	    rcThis       = this.getBoundingClientRect(),
	    posThis      = __getPosition__( this ),
	    curScrollTop = parent.scrollTop,
	    newScrollTop = posThis.top - parent.clientHeight / 2 + this.clientHeight / 2,
	    pages        = Math.abs( ( curScrollTop - newScrollTop ) / parent.offsetHeight );

	if ( forced || rcThis.top < rcParent.top + 30 || rcThis.bottom > rcParent.bottom - 30 ) {

		if ( !smooth ) {
			parent.scrollTop = newScrollTop;
		} else {
			$( parent )
				.animate( { scrollTop: newScrollTop },
				          {
					          duration: Math.min( ( 300 + Math.floor( pages ) * 40 ) * ratio, 2500 ),
					          easing  : 'easeInOutCubic',
					          complete: function () {
						          $el.blink();
					          }
				          }
				);
		}
	}

	function __getPosition__ ( el ) {
		let x = 0, y = 0;
		while ( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
			x += el.offsetLeft - el.scrollLeft;
			y += el.offsetTop - el.scrollTop;
			el = el.offsetParent;
		}
		return { top: y, left: x };
	};

};

// EASING CUT FOR ANIMATE
jQuery.extend( jQuery.easing, {
	easeInCubic   : function ( x, t, b, c, d ) { return c * ( t /= d ) * t * t + b; },
	easeOutCubic  : function ( x, t, b, c, d ) { return c * ( ( t = t / d - 1 ) * t * t + 1 ) + b; },
	easeInOutCubic: function ( x, t, b, c, d ) {
		if ( ( t /= d / 2 ) < 1 ) return c / 2 * t * t * t + b;
		return c / 2 * ( ( t -= 2 ) * t * t + 2 ) + b;
	}
} );

// - BOOKVIEWER -

//xmport './elib/swiper-home.js';

//x


//xmport './elib/bookviewer/app.js'
//xmport './elib/bookviewer/settings.js'
//
//xmport './elib/bookviewer/nav/controls.js'
//xmport './elib/bookviewer/nav/tree.js'
//
//xmport './elib/bookviewer/sys/notifier.js'
//xmport './elib/bookviewer/sys/highlighter.js'
//xmport './elib/bookviewer/sys/textcopy.js'
//xmport './elib/bookviewer/sys/bookmarks.js'
//xmport './elib/bookviewer/sys/uac.js'
//
//xmport './elib/bookviewer/help.js'
//xmport './elib/bookviewer/helpers.js'
//xmport './elib/bookviewer/loaders.js'
//xmport './elib/bookviewer/search.js'
//
//xmport './elib/bookviewer/viewport/viewport-common.js'
//xmport './elib/bookviewer/viewport/viewport-gfx.js'
//xmport './elib/bookviewer/viewport/viewport-html.js'


